<div class="container-fluid main_header">
    <div class="header container">
        <div class="logo"><img src="assets/img/beLIVE.png" alt=""></div>
        <div class="logout">Logout</div>
    </div>
</div>

<div class="container mt-5 mb-5">
    <form [formGroup]="orgForm" (ngSubmit)="submitForm()" class="form-wrapper">

        <div class="row">
            <select formControlName="organizer_type">
                <option disabled selected>Select</option>
                <option value="Organisation">Organisation</option>
                <option value="Individual">Individual</option>
            </select>
            <div class="error" *ngIf="orgForm.get('organizer_type')?.touched && orgForm.get('organizer_type')?.invalid">
                Select Organiser*
            </div>
        </div>

        <div class="row two">
            <div class="col-12">
                <input type="text" placeholder="First Name" formControlName="first_name">
                <div class="error" *ngIf="orgForm.get('first_name')?.touched && orgForm.get('first_name')?.invalid">
                    First name is required*
                </div>
            </div>
            <div class="col-12">
                <input type="text" placeholder="Last Name" formControlName="last_name">
                <div class="error" *ngIf="orgForm.get('last_name')?.touched && orgForm.get('last_name')?.invalid">
                    Last name is required*
                </div>
            </div>
        </div>

        <!-- <div class="row two"> -->

        <!-- </div> -->


        <div class="row">
            <input type="text" placeholder="Organisation Name" formControlName="organisation_name">
            <div class="error"
                *ngIf="orgForm.get('organisation_name')?.touched && orgForm.get('organisation_name')?.invalid">
                Organisation name is required*
            </div>
        </div>

        <div class="row" *ngIf="orgForm.get('organizer_type')?.value !== 'Individual'">
            <select formControlName="description">
                <option value="">Type of Organisation</option>
                <option>Corporate</option>
                <option>Startup</option>
                <option>Agency</option>
            </select>
        </div>

        <div class="row two">
            <div class="col-12">
                <select formControlName="country">
                    <option value="">Country</option>
                    <option>India</option>
                </select>
                <div class="error" *ngIf="orgForm.get('country')?.touched && orgForm.get('country')?.invalid">
                    Select Country*
                </div>
            </div>
            <div class="col-12">
                <select formControlName="city">
                    <option value="">City</option>
                    <option>Delhi</option>
                    <option>Mumbai</option>
                </select>
                <div class="error" *ngIf="orgForm.get('city')?.touched && orgForm.get('city')?.invalid">
                    Select City*
                </div>
            </div>

        </div>

        <div class="row">
            <input type="email" placeholder="Work Email" formControlName="work_email">
            <div class="error" *ngIf="orgForm.get('work_email')?.touched && orgForm.get('work_email')?.invalid">
                Enter a valid email address*
            </div>
        </div>

        <div class="row two">
            <div class="col-12">
                <select formControlName="country_code">
                <option disabled selected>Country Code</option>
                <option value="+91">+91</option>
                <option value="+971">+971</option>
            </select>
            <div class="error" *ngIf="orgForm.get('country_code')?.touched && orgForm.get('country_code')?.invalid">
                Select country code*
            </div>
            </div>
            
            <div class="col-12">
                 <input type="text" placeholder="Phone Number" formControlName="phone_number">
            <div class="error" *ngIf="orgForm.get('phone_number')?.touched && orgForm.get('phone_number')?.invalid">
                Enter a valid 10-digit mobile number*
            </div>
            </div>
           

        </div>

        <div class="row">
            <input type="text" placeholder="Website / Instagram Handle" formControlName="website">
            <div class="error" *ngIf="orgForm.get('website')?.touched && orgForm.get('website')?.invalid">
                Website name is required*
            </div>
        </div>

        <div class="row">
            <select formControlName="tickets_sold">
                <option value="">Number of tickets sold per year</option>
                <option>0 - 10K</option>
                <option>10K - 50K</option>
                <option>50K+</option>
            </select>
            <div class="error" *ngIf="orgForm.get('tickets_sold')?.touched && orgForm.get('tickets_sold')?.invalid">
                Tickets is required*
            </div>
        </div>

        <div class="row" *ngIf="orgForm.get('organizer_type')?.value !== 'Individual'">
            <select formControlName="organizer_for">
                <option disabled>What do you want to do?</option>
                <option>Sell Tickets</option>
                <option>Manage Events</option>
            </select>
            <div class="error" *ngIf="orgForm.get('organizer_type')?.touched && orgForm.get('organizer_type')?.invalid">
                Organizer is required*
            </div>
        </div>

        <div class="row">
            <textarea rows="4" placeholder="Leave us a message..." formControlName="organizer_content"></textarea>
            <div class="error"
                *ngIf="orgForm.get('organizer_content')?.touched && orgForm.get('organizer_content')?.invalid">
                Organizer Content is required*
            </div>
        </div>

        <div class="checkbox">
            <input type="checkbox" formControlName="agree" style="width: 3%;">
            <span>
                By submitting, you agree to our <a href="#">Privacy Policy</a> and consent to be contacted via email/phone/SMS regarding this request.
                
            </span>
        </div>

        <p class="note">Our team reviews requests within 24–48 hours.</p>

        <button type="submit">Submit</button>
    </form>


</div>